import React from "react";
import { Stack, UnstyledButton, Group, Text, Box } from "@mantine/core";
import { CRAM_LISTS } from "../cramListsRegistry";

interface Props {
    selectedListId: string;
    onSelect: (listId: string) => void;
    itemCounts: Record<string, number | undefined>;
}

const CramListPicker: React.FC<Props> = ({
    selectedListId,
    onSelect,
    itemCounts,
}) => {
    return (
        <Stack gap={4}>
            {CRAM_LISTS.map((list) => {
                const active = list.id === selectedListId;
                const count = itemCounts[list.id];
                return (
                    <UnstyledButton
                        key={list.id}
                        onClick={() => onSelect(list.id)}
                        style={{
                            padding: "6px 8px",
                            borderRadius: 6,
                            border: `1px solid ${
                                active
                                    ? "var(--mantine-color-blue-5)"
                                    : "var(--mantine-color-gray-3)"
                            }`,
                            background: active
                                ? "var(--mantine-color-blue-0)"
                                : "transparent",
                        }}
                    >
                        <Group justify="space-between" wrap="nowrap" gap={6}>
                            <Box style={{ minWidth: 0, flex: 1 }}>
                                <Text fw={500} size="sm" lineClamp={1}>
                                    {list.labelEn}
                                </Text>
                            </Box>
                            {count != null && (
                                <Text size="xs" c="dimmed">
                                    {count}
                                </Text>
                            )}
                        </Group>
                    </UnstyledButton>
                );
            })}
        </Stack>
    );
};

export default CramListPicker;
